import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import './atlas.css'
//import './index.css'

import Header from './Header'
import Footer from './Footer'
import RightBox from './RightBox'
import { LeftMenu, SmallMenu } from './menus'

import getMenuEntries from './getMenuEntries'

class DefaultLayout extends React.Component {
  render() {
    const isHomepage = this.props.location.pathname == `/`
    const menuEntries = getMenuEntries(
      this.props.data.site.edges.map(({ node: { path, fields } }) => ({
        path,
        ...fields,
      })),
      this.props.location.pathname
    )

    return (
      <div>
        <Helmet
          title="Kinderbetreuungsatlas Burgenland"
          meta={[
            {
              name: 'description',
              content: 'Kinderbetreuungsatlas Burgenland',
            },
            {
              name: 'keywords',
              content: 'AK, Kinderbetreuungsatlas, Burgenland',
            },
          ]}
        />
        <Header isHomepage={isHomepage} />
        {isHomepage ? (
          <div className="redbar" />
        ) : (
          <SmallMenu entries={menuEntries} />
        )}
        <div
          className="main-content"
          style={
            isHomepage
              ? {
                  borderBottom: '1px solid #ddd',
                  marginBottom: '0',
                  minHeight: '410px',
                }
              : null
          }
        >
          {!isHomepage && <LeftMenu entries={menuEntries} />}
          {this.props.children()}
          <RightBox isHomepage={isHomepage} />
        </div>
        <RightBox small="true" isHomepage={isHomepage} />
        <Footer isHomepage={isHomepage} data={this.props.data} />
      </div>
    )
  }
}

DefaultLayout.propTypes = {
  children: PropTypes.func,
}

export default DefaultLayout

export const query = graphql`
  query IndexQuery {
    site: allSitePage(filter: { fields: { title: { regex: "/./" } } }) {
      edges {
        node {
          path
          fields {
            title
            parentTitle
            rootTitle
            suffix
            year
          }
        }
      }
    }
    kriterien: allSitePage(filter: { path: { regex: "/Kriterien/./" } }) {
      edges {
        node {
          path
          fields {
            title
            parentTitle
            suffix
            year
          }
        }
      }
    }
    einrichtungen: allSitePage(
      filter: { path: { regex: "/Betreuungseinrichtungen/./" } }
    ) {
      edges {
        node {
          path
          fields {
            title
            parentTitle
          }
        }
      }
    }
    logoBannerSlice0: imageSharp(id: { regex: "/LogoBanner_0_0.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 118) {
        ...GatsbyImageSharpSizes
      }
    }
    logoBannerSlice1: imageSharp(id: { regex: "/LogoBanner_0_1.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 144) {
        ...GatsbyImageSharpSizes
      }
    }
    logoBannerSlice2: imageSharp(id: { regex: "/LogoBanner_0_2.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 116) {
        ...GatsbyImageSharpSizes
      }
    }
    logoBannerSlice3: imageSharp(id: { regex: "/LogoBanner_0_3.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 169) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js